import styled from "styled-components"

export const AgreementNoticeText = styled.p`
  font-weight: bold;
`
